<template>
  <div class="pa-form-group" role="radio" :aria-checked="shouldBeChecked">
    <input
      type="radio"
      :id="value"
      :disabled="disabled"
      :value="value"
      :checked="shouldBeChecked"
      :aria-checked="shouldBeChecked"
      @change="updateInput"
      :class="computedClass"
      ref="radio-button"
    />
    <label :for="value" tabindex="0">{{ label }}</label>
  </div>
</template>

<script>import themeSetupMixin from '@/mixins/theme';

export default {
  inheritAttrs: false,
  mixins: [themeSetupMixin],
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: {
      type: String,
    },
    /**
     * @model
     * */
    modelValue: {
      default: '',
      type: [String, Array],
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    /**
     * The type of the radio
     * @values primary, secondary, success, danger
     * @default is primary
     * */
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'success', 'danger'].indexOf(value) !== -1,
    },
    /**
     * The size of the radio
     * @values small, medium, large
     * @default is medium
     * */
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].indexOf(value) !== -1,
    },
  },
  computed: {
    /**
     * This checks if the v-model whether an array or string includes/contains/is the value,
     * to update the check status
     * */
    shouldBeChecked() {
      return this.modelValue === this.value;
    },
    computedClass() {
      return `pa-${this.type} pa-${this.size}`;
    },
  },
  methods: {
    updateInput() {
      /**
       * @event change
       * @param {string} this.value prop
       * */
      this.$emit('change', this.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import './radio';
</style>
